module.exports = __webpack_public_path__ + "static/ufo_img3-9d789937cd356d3fe8f137849f14f699.png";